<template>
        <div>
            <ContactNoSaveWindow @confirmNext="confirmNext"/>
            <SaveWindow text="Данные успешно сохранены"/>
            <SaveEmailWindow v-show="showEmailWindow"/>
            <div class="layout">
                <div class="cabinet-page_bg"></div>

                <HeaderAuth/>
                <div class="cabinet-content-block-wrapper">
                    <div class="cabinet-content-block">

                        <ClientNavigation/>
                        <div class="cabinet-content">
                            <div class="heading-wrapper">
                                <div class="title" v-html="$ml.with('VueJS').get('profile')"></div>
                            </div>
                            <div class="cabinet-content-inner">

                                <div class="form form-wrap">

                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.surname}"
                                    >
                                        <label>Фамилия&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <input v-model.trim="user.surname"
                                                   name="surname"
                                                   ref="surname"
                                                   type="text"
                                                   v-validate="'required'"
                                                   autocomplete="off"
                                                   @input="valErrors.surname = false; isChanged = true"
                                            >
                                            <div v-show="valErrors.surname" class="msg-form msg-error-field">
                                                Заполните обязательное поле
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.nameAndPatronymic}"
                                    >
                                        <label>Имя и Отчество&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <input v-model.trim="nameAndPatronymic"
                                                   name="nameAndPatronymic"
                                                   ref="nameAndPatronymic"
                                                   type="text"
                                                   v-validate="'required'"
                                                   autocomplete="off"
                                                   @input="valErrors.nameAndPatronymic = false; isChanged = true"
                                            >
                                            <div v-show="valErrors.nameAndPatronymic" class="msg-form msg-error-field">
                                                Заполните обязательное поле
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.email}"
                                    >
                                        <label>Email&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <input v-model.trim="user.email"
                                                   name="email"
                                                   type="text"
                                                   autocomplete="off"
                                                   ref="email"
                                                   v-validate="'required|email'"
                                                   v-on:keydown="registerStatus = registerStatuses.newReg"
                                                   @input="valErrors.email = false; isChanged = true"
                                            >
                                            <div v-show="valErrors.email" class="msg-form msg-error-field">
                                                {{errors.first('email')}}
                                            </div>
                                            <div v-show="registerStatus === registerStatuses.emailTaken"
                                                 class="msg-form msg-error-field">
                                                Такой email уже зарегистрирован в системе
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-field-input-2"
                                         :class="{'error-field' : valErrors.phone}"
                                    >
                                        <label>Номер телефона&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <vue-tel-input v-model="user.phone"
                                                           :wrapperClasses="{'dev_error_tel_input' : valErrors.phone}"
                                                           placeholder="Введите номер телефона"
                                                           name="phone"
                                                           v-validate="'required'"
                                                           @input="phoneInput"
                                                           @country-changed="countryChanged"
                                                           @validate="phoneValidate"
                                                           ref="phoneNumber"
                                            ></vue-tel-input>
                                            <div v-show="valErrors.phone" class="msg-form msg-error-field">
                                                {{valErrors.phoneMessage}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="other-contacts-list">

                                    </div>

                                    <div v-for="link in links" class="form-field-input-2">
                                        <label>Дополнительный канал связи</label>
                                        <div class="field-input-wrapper">
                                            <input v-model="link.data" type="text" required="" value="" @input="isChanged = true">
                                            <div class="msg-form">Введите дополнительный номер телефона, email или любой другой канал, по которому мы можем с Вами связаться</div>
                                        </div>
                                        <button @click="deleteLink(link)" class="button-del-field" title="Удалить дополнительный канал связи">
                                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.05025 7.05024L16.9497 16.9497M16.9497 7.05024L7.05025 16.9497" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                        </button>
                                    </div>
                                    <button v-show="links.length < 3" class="button-nobg-icon add-other-contact" @click="this.addLink">
                                        <span class="icon">
                                            <PlusIcon/>
                                        </span>
                                        <span class="text">Добавить канал связи</span>
                                    </button>

                                    <div class="button-block">
                                        <button class="button button-dark modal-save-email"
                                                :disabled="pressed"
                                                type="button"
                                                @click="this.save"
                                        >
                                            Сохранить
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <FooterAuth/>
        </div>
</template>



<script>
    import HeaderAuth from "../components/HeaderAuth";
    import ClientNavigation from "../components/ClientNavigation";
    import FooterAuth from "../components/FooterAuth";
    import PlusIcon from "../components/icons/PlusIcon";
    import { VueTelInput } from 'vue-tel-input'
    import SaveEmailWindow from '../components/windows/SaveEmailWindow.vue';
    import SaveWindow from "@/components/windows/SaveWindow";
    import ContactNoSaveWindow from "@/components/windows/ContactNoSaveWindow";

    const registerStatusesInternal = Object.freeze({
        newReg: 1,
        success: 2,
        emailTaken: 3
    });

    const notFilledMessage = 'Заполните обязательное поле';
    const phoneErrorMessage = 'Введите корректный номер телефона';

    export default {
        name: 'ClientProfile',
        components: {
            ContactNoSaveWindow,
            SaveWindow, PlusIcon, FooterAuth, ClientNavigation, HeaderAuth, VueTelInput, SaveEmailWindow},

        metaInfo: {
            title: 'Профиль | Your Last Word'
        },

        data() {
            return {
                user: {
                    surname: '',
                    name: '',
                    patronymic: '',
                    email: '',
                    phone: '',
                },
                oldEmail: '',
                nameAndPatronymic: '',
                emailRepeat: '',
                registerStatuses: registerStatusesInternal,
                registerStatus: registerStatusesInternal.newReg,
                pressed: false,
                links: [],
                showEmailWindow: false,
                valErrors: {
                    email: false,
                    phone: false,
                    surname: false,
                    nameAndPatronymic: false,
                    phoneMessage: ''
                },
                intlTelNumber: {},
                intlTelCountry: {},
                defaultCountry: 'RU',
                isChanged: false,
                next: {}
            };
        },

        beforeCreate() {
            $('body').attr('class', 'cabinet-page');
        },

        async created() {
            await this.$store.dispatch('loadCurrentUserData');
            let user = this.$store.getters.currentUser;
            this.user.surname = user.surname;
            this.user.name = user.name;
            this.user.patronymic = user.patronymic === null ? '' : user.patronymic;
            this.user.email = user.email;
            this.user.phone = user.phone === null ? '' : user.phone;
            this.nameAndPatronymic = this.user.name + ' ' + this.user.patronymic;
            this.oldEmail = user.email;
            user.linkList.forEach(link => this.links.push(link));
        },

        computed: {
            isBlocked() {
                return !(Object.keys(this.fields).every(key => this.fields[key].valid))
            }
        },

        methods: {
            async save() {
                this.pressed = true;
                let errors = false;

                if (this.errors.has('email') || this.registerStatus.emailTaken) {
                    this.valErrors.email = true;
                    errors = true;
                }


                if (!$.isEmptyObject(this.intlTelNumber) && !this.intlTelNumber.isValid) {
                    this.valErrors.phone = true;
                    this.valErrors.phoneMessage = phoneErrorMessage;
                    errors = true;
                }

                if (this.user.phone.trim() === '') {
                    this.valErrors.phone = true;
                    this.valErrors.phoneMessage = notFilledMessage;
                    errors = true;
                }

                if (this.user.surname.trim() === '') {
                    this.valErrors.surname = true;
                    errors = true;
                }

                if (this.nameAndPatronymic.trim() === '') {
                    this.valErrors.nameAndPatronymic = true;
                    errors = true;
                }

                if (!errors) {
                    let names = this.nameAndPatronymic.split(' ');
                    let emailChanged = this.oldEmail !== this.user.email;
                    let userReg = {
                        surname: this.user.surname,
                        name: names.length > 1 ? names.slice(0, -1).join(' ') : names[0],
                        patronymic: names.length > 1 ? names.slice(-1).join(' ') : '',
                        email: this.user.email,
                        phone: this.intlTelNumber.number.international,
                        linkList: this.links.filter(link => link.data.trim() !== '')
                    };
                    let success = await this.$store.dispatch('updateUserData', userReg);
                    if (!!success) {
                        this.links = this.links.filter(link => link.data.trim() !== '');
                        this.registerStatus = this.registerStatuses.success;
                        if (emailChanged) {
                            this.showEmailWindow = true;
                            this.user.email = this.oldEmail;
                            $('.window-wrapper.window-save-email').addClass('window-open');
                            $('body').addClass('blocked');
                        } else if (this.isChanged) {
                            $('.window-wrapper.window-save-contacts').addClass('window-open');
                            $('body').addClass('blocked');
                        }
                        this.isChanged = false;
                    } else {
                        this.registerStatus = this.registerStatuses.emailTaken;
                    }
                }
                this.pressed = false;
            },
            addLink() {
                if (this.links.length < 3) {
                    this.links.push({id:0, data: ''});
                }
            },
            deleteLink(link) {
                const index = this.links.indexOf(link);
                if (index > -1) {
                    this.isChanged = true;
                    this.links.splice(index, 1);
                }
            },
            phoneInput(number, tel) {
                this.isChanged = true
                this.valErrors.phone = false;
                this.intlTelNumber = {number: tel.number, isValid: tel.isValid};

                if (tel.number.international) {
                    let index = tel.number.international.indexOf(" ");
                    this.user.phone = tel.number.international.slice(index + 1);
                }
            },
            countryChanged(country) {
                this.intlTelCountry = country;
                this.defaultCountry = country.iso2;
                this.$refs.phoneNumber.choose(this.defaultCountry);

                if (this.user.phone && this.user.phone.includes("+")) {
                    this.user.phone = this.user.phone.replace("+".concat(country.dialCode), "");
                }
            },
            phoneValidate(tel) {
                this.intlTelNumber = {number: tel.number, isValid: tel.isValid};
                if (tel.isValid) {
                    this.defaultCountry = tel.regionCode;
                    this.$refs.phoneNumber.choose(tel.regionCode);
                }

                if (tel.number.international) {
                    let index = tel.number.international.indexOf(" ");
                    this.user.phone = tel.number.international.slice(index + 1);
                }
            },
            confirmNext() {
                this.next();
            }
        },

        beforeRouteLeave (to, from, next) {
            if (this.isChanged) {
                $('.window-wrapper.window-no-save-contacts').addClass('window-open');
                $('body').addClass('blocked');
                this.next = next;
            } else {
                next();
            }
        },
    }
</script>

<style>
    .cabinet-content-inner button:disabled {
        opacity: 0.3;
    }

    .dev_error_tel_input {
      border-color: #dd5656 !important;
      color: #dd5656;
    }

    .vti__dropdown {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .vti__dropdown-item {
        color: #000 !important;
    }

    .vue-tel-input:focus-within {
        box-shadow: none !important;
        border-color: #000 !important;
    }
</style>